<template>
  <div></div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'logout',
    mounted () {
      this.loadLogout()
    },
    methods: {
      loadLogout () {
        this.redirectToLogin()
      },
      redirectToLogin () {
        localStorage.clear()
        if (this.institution) {
          let shortName = this.institution.shortName
          let signupLink = this.institution.selfRegistrationLink
          let logoutUrl = this.institution.ssoLogoutUrl
        if(logoutUrl) {
            window.location.href = logoutUrl
        } else if (shortName && signupLink && shortName.length > 0 && signupLink.length > 0) {
            window.location.href = '/signin/' + shortName
          } else {
            return this.$router.push({ name: 'login' })
          }
        } else {
          return this.$router.push({ name: 'login' })
        }
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.dashboard.institution
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/login/components/Logout.vue